const REMINDER_TITLE = 'Share your screen';
const REMINDER_BODY = 'You are punched in but screen share is off. Please share your screen on your work computer.';

export const canUseNotifications = () => (
  typeof window !== 'undefined' && typeof Notification !== 'undefined'
);

export const getNotificationPermission = () => {
  if (!canUseNotifications()) {
    return 'unsupported';
  }
  return Notification.permission;
};

export const requestNotificationPermission = async () => {
  if (!canUseNotifications()) {
    return 'unsupported';
  }
  if (Notification.permission === 'granted') {
    return 'granted';
  }
  if (Notification.permission === 'denied') {
    return 'denied';
  }
  try {
    return await Notification.requestPermission();
  } catch (err) {
    return Notification.permission;
  }
};

export const showScreenShareNotification = async () => {
  if (!canUseNotifications()) {
    return false;
  }

  let permission = Notification.permission;
  if (permission === 'default') {
    permission = await requestNotificationPermission();
  }
  if (permission !== 'granted') {
    return false;
  }

  try {
    const notification = new Notification(REMINDER_TITLE, {
      body: REMINDER_BODY,
      tag: 'hrms-screen-share-reminder',
      renotify: true,
      requireInteraction: true,
    });
    notification.onclick = () => {
      try {
        window.focus();
      } catch (err) {}
      notification.close();
    };
    return true;
  } catch (err) {
    return false;
  }
};
